import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  Button,
  FormGroup,
  ControlLabel,
  FormControl,
  Tooltip,
  OverlayTrigger,
} from 'react-bootstrap'
import { WizardSteps } from '../../components'
import { updateBadgeInfo } from '../actions'
import { linkPaths, COURSENUM } from '../urls'
import BadgeName from './BadgeName'
import IncompleteBadgeImage from './IncompleteBadgeImage'
import CompleteBadgeImage from './CompleteBadgeImage'

const Design = props => {
  const goBack = e => {
    e.preventDefault()
    window.location = `/instructor/achievements/${COURSENUM}/`
  }

  const goNext = e => {
    e.preventDefault()
    let { history } = props
    history.push(linkPaths.requirements)
  }

  const handleChange = change => {
    props.updateInfo({ description: change })
  }

  const needsRequirements = props.name.length === 0

  const imageTooltip = (
    <Tooltip id="image_tooltip">
      Icon will be cropped to 100x100
      <br />
      Icon can be 1 MB or less
    </Tooltip>
  )

  return (
    <div>
      <WizardSteps
        edit={props.retrievedEditData}
        step={1}
        linkPaths={linkPaths}
        heading="Badge"
        subHeading="Build Badge"
        annotation="Click an item to edit the content"
      />
      <div id="badge_box">
        <div className="text-center" id="badge_name">
          <BadgeName />
        </div>
        <div id="images">
          <div className="image" id="incompleteImage">
            <OverlayTrigger placement="right" overlay={imageTooltip}>
              <span>Incomplete Icon</span>
            </OverlayTrigger>
            <IncompleteBadgeImage />
          </div>
          <div className="image" id="completeImage">
            <OverlayTrigger placement="right" overlay={imageTooltip}>
              <span>Complete Icon</span>
            </OverlayTrigger>
            <CompleteBadgeImage />
          </div>
        </div>
        <div style={{ marginLeft: '5%', marginRight: '5%' }}>
          <FormGroup controlId="descriptionID">
            <ControlLabel>Description</ControlLabel>
            <FormControl
              componentClass="textarea"
              onChange={e => handleChange(e.target.value)}
              value={props.description}
            />
          </FormGroup>
        </div>
      </div>
      <div className="btn_container">
        <Button bsStyle="primary" onClick={goBack}>
          Back
        </Button>
        <Button bsStyle="primary" disabled={needsRequirements} onClick={goNext}>
          Next
        </Button>
      </div>
    </div>
  )
}

Design.propTypes = {
  history: PropTypes.object,
  retrievedEditData: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  updateInfo: PropTypes.func.isRequired,
}

const mapStateToProps = state => {
  return {
    retrievedEditData: state.badgeInfo.retrievedEditData,
    description: state.badgeInfo.description,
    name: state.badgeInfo.name,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updateInfo: badgeInfo => {
      dispatch(updateBadgeInfo(badgeInfo))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Design)
